// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1wS7-","list":"BalanceDue_list__1PF-a","listRow":"BalanceDue_listRow__8rBkz","total":"BalanceDue_total__1bqJI"};